import { ca } from '@cian/analytics';
import { toAnalyticsObjectType } from './toAnalyticsObjectType';
import { getBlockTypeByInfrastructureType } from './getBlockTypeByInfrastructureType';
import { TRegularInfrastructureItem } from '../../../types/map';

export function trackPanoramaShow(
  isPanorama: boolean,
  infrastructureItems: TRegularInfrastructureItem[],
  infrastructureType?: string,
) {
  const objectType = toAnalyticsObjectType(infrastructureType);
  const blockType = getBlockTypeByInfrastructureType(infrastructureType, infrastructureItems);

  ca('eventSite', {
    action: 'panorama',
    category: 'Infrastructure',
    label: isPanorama ? 'click_sopr' : 'close_sopr',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
